function CustomerOverview() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Project.Customer visual. <br/>
    /// <br/>
    /// Author: MWI<br />
    /// Date: 12.05.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 07.12.2016                                              *<br />
    /// **********************************************************************<br />
    /// * - filter set for vc-list                                           *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 20.06.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - copy from project Overview                                       *<br />
    /// **********************************************************************<br />
    /// </summary>
}
CustomerOverview.prototype = new vcTemplate();
CustomerOverview.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it adds the clickhandler,  <br/>
    /// initializes the search <br/>
    /// and fills the list elements with the assignments
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        me.initTags();

    
        //me.filter();
        me.visual.find(".vc-filter").vcFilter({ callback: function () { me.filter(); } });


        me.visual.find(".vc-list-table .vc-list-item").filter(":visible").filter(":even").addClass("alt");
       
        me.visual.find("#lstProjects").height(parseInt(me.height - me.visual.find("#divProjectOverview").outerHeight()));

        //me.addFilter();
        me.initClickHandler();
        //me.filter();
        return true;
    } catch (ex) {
        me.writeError('CustomerOverview.init', ex);
        return false;
    }

};
CustomerOverview.prototype.initTags = function () {
    /// <summary>
    /// adds the tags (projects) to the customer <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find("#lstProjects .vc-list-item").each(function (idx, element) {
            var tags = $("<div>");
            var blid = $(element).data("customerid");
            tags.attr("class", "tagList");
            var assignments = $.grep(me.lstProjectAssignments, function (a) {
                return a.mainid === blid;
            });
            if (assignments.length < 1) {
                tags.append("<div class='tag error'>" + me.resources.noEntriesExist + "</div>");
            } else {
                assignments.forEach(function (ass) {

                    tags.append("<div class='tag'>" + me.lstProjects[ass.assid] + "</div>");
                });
            }
            $(element).find(".col3").html("").append(tags);
        });
    } catch (ex) {
        me.writeError('CustomerOverview.init', ex);
        return false;
    }
    return true;
};

CustomerOverview.prototype.doEvent = function (event) {
    /// <summary>
    /// Handles the events in the Customer Overview <br/>
    /// has currently only the Event CUST_DET_BACK, which sees that the list is shown again in the end
    /// </summary>
    var me = this;
    try {
        switch (event.msg) {
            case "CUSTOMER_CHANGED", "CUST_DET_BACK":
                me.visual.find("#lstHeader").show();
                window.VisualCoreService.getDataByName("WIDGET_PROJECT_CUSTOMER_LIST", me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 2, JSON.stringify({ 'loadType': 1 }), function (result) {
                    var resObj = JSON.parse(result);
                    me.visual.find("#lstProjects").html(resObj.retHTML);
                    me.initTags();
                    me.filter();
                    me.initClickHandler();
                });

                break;
            default:
                //me.writeError('ProjectOverview.doEvent', "No such Event in CustomerOverview");
                break;
        }
        return true;
    } catch (ex) {
        me.writeError('ProjectOverview.doEvent', ex);
        return false;
    }
};

CustomerOverview.prototype.initClickHandler = function () {
    ///<summary>
    ///Initializes the clickable elements namely the new button (calls the creation view) and the list elements (call the detailview)
    ///</summary>
    var me = this;
    try {
        me.visual.find('#lstProjects .vc-list-item').off("click").on("click", function () {
            me.visual.find('#projectFilters').html("");
            me.visual.find('#lstHeader').hide();
           
            me.vcVisual.addVisualContentByName("lst", "WIDGET_PROJECT_CUSTOMERDETAIL", "Projects", getCurrentTimestamp(), parseInt(me.visual.find("#lstProjects").height()), 1100, "", JSON.stringify({ 'customerid': $(this).attr("data-customerid") }), 1);

        });
        return true;
    } catch (ex) {
        me.writeError('CustomerOverview.initClickHandler', ex);
        return false;
    }
};

CustomerOverview.prototype.filter = function () {
    /// <summary>
    /// This function adds/removes two css-classes ('found' and 'exclude') for filtering loggers.<br/>
    /// When a logger with a filter expression gets found the 'found' class gets added - and the other way round for the 'exclude' class. <br/>
    /// At the end, basically all 'found' classes get shown and all 'exclude' classes get hidden - the favorites state gets considered as well.<br/>
    /// </summary>
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        //hide all
        me.visual.find(".vc-list-table .vc-list-item").removeClass("found").data("counterfound", 0).hide();
        //me.visual.find("#col1.vc-filter, #col2.vc-filter, #col3.vc-filter, #col4.vc-filter").trigger("change");

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", ".vc-list-table .vc-list-item", "found");
        me.visual.find(".vc-list-table .vc-list-item.found").show();
        me.visual.find(".vc-list-table .vc-list-item").removeClass("alt");
        me.visual.find(".vc-list-table .vc-list-item.found:even").addClass("alt");

        return true;
    } catch (ex) {
        me.writeError('ProjectOverview.filter', ex);
        return false;
    }
};
CustomerOverview.prototype.setTagFilter = function (filterObj, listItem, classFound) {
    /// <summary>
    /// This function takes all tags from the vcFilter widget (filterObj) and adds a 'classFound' css class to all entries it founds in 'listItem'.<br/>
    /// It is used as part of the filter function in vc-lists
    /// </summary>
    var me = this;
    var countertext;
    try {
        countertext = "counterfound";
        //we reset the counter for found entries
        me.visual.find(listItem).data(countertext, 0);

        //we filter the optional tags we got from the vc-tags
        var filter = me.visual.find(filterObj).vcFilter("getFilter");

        if (filter !== null) {
            var counter;
            //first, we count how often we find the filter tags in every signal item
            for (var i = 0; i <= filter.length - 1; i++) {
                if (filter[i].length > 0) {
                    me.visual.find(listItem + ":contains('" + filter[i] + "')")
                        .each(function () {
                            counter = parseInt($(this).closest(".vc-list-item").data(countertext), 10);
                            if (isNaN(counter)) { counter = 0 }
                            counter++;
                            $(this).closest(".vc-list-item").data(countertext, counter);
                        });
                }
            }
            //if we found them as often as the number of filter tags - we are the lucky winner and show the entry!!
            //why? if we have several filter tags we have to find all of them in one single signal 
            me.visual.find(listItem)
                .each(function () {
                    if (parseInt($(this).data(countertext), 10) === filter.length) {
                        $(this).addClass(classFound);
                    }
                });
        } else {

            me.visual.find(listItem).addClass(classFound);
        }
    } catch (ex) {
        me.writeError(me.source + '.JS.setTagFilter', ex);
    }
};